import { FC } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { UserProtectedRoute } from 'routes'
import CommonRoomReservationsList from 'components/CommonRoomReservations/CommonRoomReservationsList'

// Index route of /common-room-reservations. On desktop the list lives in the
// Helpdesk layout's left column; on mobile it renders here.
const CommonRoomReservationsPage: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return <UserProtectedRoute>{!isDesktop && <CommonRoomReservationsList />}</UserProtectedRoute>
}

export default CommonRoomReservationsPage
